import { useIntersectionObserver, useSyncedRef, useThrottledCallback } from "@react-hookz/web";
import { useCallback, useEffect, useState } from "react";
export const useTrackImpressionEventByIntersection = parameters => {
  const {
    ga4TrackingHandler,
    gaTrackingHandler,
    getEvent,
    getGa4Event,
    options
  } = parameters;
  const latestGetEvent = useSyncedRef(getEvent);
  const latestGetGa4Event = useSyncedRef(getGa4Event);
  const [targetElement, setTargetElement] = useState(null);
  const [hasSent, setHasSent] = useState(false);
  const shouldSend = options !== null && options !== void 0 && options.shouldSendOnce ? !hasSent : true;
  const intersection = useIntersectionObserver(shouldSend && (latestGetEvent.current || latestGetGa4Event.current) ? targetElement : null, {
    threshold: options === null || options === void 0 ? void 0 : options.intersectionThreshold
  });
  const handleSend = useThrottledCallback((event, ga4Event) => {
    if (options !== null && options !== void 0 && options.isSendGATracking && event && gaTrackingHandler) {
      gaTrackingHandler(event);
    }
    if (options !== null && options !== void 0 && options.isSendGA4Tracking && ga4Event && ga4TrackingHandler) {
      ga4TrackingHandler(ga4Event);
    }
    setHasSent(true);
  }, [gaTrackingHandler, ga4TrackingHandler, setHasSent], options !== null && options !== void 0 && options.shouldThrottle ? 300 : 0, true);
  useEffect(() => {
    if (!shouldSend || !(intersection !== null && intersection !== void 0 && intersection.isIntersecting) || !latestGetEvent.current && !latestGetGa4Event.current) return;
    handleSend(latestGetEvent.current ? latestGetEvent.current() : null, latestGetGa4Event.current ? latestGetGa4Event.current() : null);
  }, [shouldSend, intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting, handleSend, latestGetEvent, latestGetGa4Event]);
  useEffect(() => {
    setHasSent(false);
  }, [targetElement]);
  const captureTrackImpressionEventTargetElement = useCallback(element => {
    setTargetElement(element);
  }, [setTargetElement]);
  return {
    captureTrackImpressionEventTargetElement,
    intersection
  };
};